'use strict';

const Mn = require('backbone.marionette');
const SidebarNavListView = require('common/ui/view/sidebar/nav');
const SearchView = require('system/ui/view/search');
const ModalView = require('common/ui/view/modal/index');
const ToolbarMenuView = require('system/ui/view/toolbar-menu');
const DiagramEditView = require('system/ui/view/modal/diagram-edit');
const DiagramSyncStateView = require('system/ui/view/diagram-sync-state');
const SymbolicNodeAddView = require('system/ui/view/modal/symbolic-node-add');
const ViewerRepository = require('balus/domain/repository/viewer');
const ViewerListView = require('balus/ui/view/viewer/list');
const LockNoticeTemplate = require('balus/ui/template/body/diagram/toolbar/lock-notice.hbs');
const Template = require('balus/ui/template/body/diagram/toolbar/index.hbs');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        menu: '.menu',
        search: '.search',
        viewer: '.viewers',
        state: '.syncstate',
        nav: '.sidebar-nav'
    },
    ui: {
        diagramEditButton: '.edit-diagram',
        addNodeButton: '.add-node',
        lockCheckbox: '.lock',
        lockForm: '.lock-form'
    },
    events: {
        'click @ui.diagramEditButton': 'editDiagram',
        'click @ui.addNodeButton': 'addNode',
        'click @ui.lockCheckbox': 'lock',
    },

    templateContext: function() {
        return {
            isLocked: this.getOption('auth').isLocked()
        };
    },

    onRender: function() {
        const context = this.getOption('context');
        const oldContext = this.getOption('oldContext');
        const channel = this.getOption('channel');
        const messengerChannel = this.getOption('messengerChannel');
        const auth = this.getOption('auth');
        const group = this.getOption('group');
        const project = this.getOption('project');

        this.showChildView('menu', new ToolbarMenuView({
            model: this.model,
            auth: auth,
            context: oldContext,
            channel: channel,
            project: project,
        }));

        this.showChildView('state', new DiagramSyncStateView({
            model: this.model,
            context: oldContext,
            channel: channel
        }));

        this.showChildView('search', new SearchView({
            context: oldContext,
            members: group.getMembers()
        }));
        channel.reply('search', query => {
            this.getChildView('search').query(query);
        });

        const view = new SymbolicNodeAddView({
            diagram: this.model,
            context: oldContext,
            channel: channel
        });
        channel.reply('cmd:menu:symbolic:render', view.show);
        $('#modal-container').append(view.render().el);

        const viewers = ViewerRepository.getViewer(context);
        this.showChildView('viewer', new ViewerListView({
            viewers: viewers.getUsers(),
            context: oldContext,
            user: this.getOption('user')
        }));

        this.listenTo(auth, 'lock:edit', this.showLockNotice);
        this.listenTo(auth, 'change:lock', () => {
            this.ui.lockCheckbox.prop('checked', auth.isLocked());
        });

        if(auth.getMode() == 'snapshot') {
            this.ui.addNodeButton.hide();
            this.ui.lockForm.hide();
        }
    },

    onAttach: function() {
        $.material.init();
    },

    renderNav: function(navs) {
        this.showChildView('nav', new SidebarNavListView({
            collection: navs,
            horizontal: true
        }));
    },

    editDiagram: function() {
        const project = this.getOption('project');
        const modal = new ModalView({
            title: i18n.t('base:title.diagram.setting'),
            bodyView: new DiagramEditView({
                model: this.model,
                project: project
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    addNode: function() {
        this.getOption('channel').request('toolbar:addNode');
    },

    lock: function() {
        if(this.ui.lockCheckbox.prop('checked')) {
            this.getOption('auth').lock();
            this.model.setEditLock(true);
        } else {
            this.getOption('auth').unlock();
            this.model.setEditLock(false);
        }
    },

    showLockNotice: function() {
        this.$('.lock-notice').popover({
            html: true,
            content: LockNoticeTemplate(),
            placement: 'bottom'
        });

        this.$('.lock-notice').popover('show');

        setTimeout(() => {
            this.hideLockNotice();
        }, 3000);

        this.$('.popover').on('click', () => {
            this.hideLockNotice();
        });
    },

    hideLockNotice: function() {
        this.$('.lock-notice').popover('hide');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/toolbar/index.js